import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    exportButton: {
        height: '30px',
        padding: '4px 12px',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        textTransform: 'capitalize',
        backgroundColor: '#EBA900',
        color: '#FFFFFF',
        fontSize: '0.8rem',
        fontWeight: 'normal',
        borderRadius: 3,

        '&:hover': {
            backgroundColor: '#EB7F00',
        },

        '& > svg': {
            paddingRight: 5,
        },
    },
}));
